export default __webpack_public_path__ + "static/media/error-icon.07461710.svg";